import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploaderComponent } from './uploader.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [UploaderComponent],
  imports: [CommonModule, MatIconModule],
  exports: [UploaderComponent],
})
export class UploaderModule {}
